var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cotacnt-form-tel"},[_c('div',{staticClass:"number"},[_c('div',{staticClass:"box"},[_c('p',[_c('a',{attrs:{"href":"tel:0566953210"}},[_vm._v("0566-95-3210")]),_c('br',{staticClass:"sp-kaigyo"}),_c('span',[_vm._v("（平日：9時～17時まで）")])])])])])
}]

export { render, staticRenderFns }